module.exports = __webpack_public_path__ + "images/second-place.png";